import React from "react";
import "./styles.scss";
import { Text } from "atoms";

export default props => (
  <div className="footer-column">
    {props.options.map(element => {
      return <Text href={element.href} 
                   text={element.text} 
                   id={element.href}
                   onClick={ event => {
                      window.scroll({top: 0, left: 0, behavior: 'smooth' })
                      window.location.href = element.href
                   }} />
    })}
  </div>
);
